// src/utils/buildExtractionFields.ts
import { TextArea } from "./types";

interface DerivedFieldConfig {
  id: string;
  description: string;
}

// For fields that are being extracted from one extraction field
// the description for this extraction field is defined once
const DERIVED_SOURCE_DESCRIPTIONS: Record<string, string> = {
  presentation_title: "The full title of the presentation, exactly as it appears in the text, without any modification.",
};

export function buildExtractionFields(textAreas: TextArea[]): DerivedFieldConfig[] {
  const fields = new Map<string, string>();

  for (const area of textAreas) {
    if (area.derivedFrom) {
      // Abgeleitetes Feld -> Ursprungsfeld eintragen (nur einmal, auch wenn mehrere Teile darauf verweisen)
      if (!fields.has(area.derivedFrom)) {
        fields.set(area.derivedFrom, DERIVED_SOURCE_DESCRIPTIONS[area.derivedFrom] ?? area.derivedFrom);
      }
    } else if (area.description) {
      // Normales Feld -> direkt übernehmen
      fields.set(area.id, area.description);
    }
  }

  return Array.from(fields.entries()).map(([id, description]) => ({ id, description }));
}